module.exports = __webpack_public_path__ + "static/img/buyCar.b80de3e7.svg";